/* Tea Lab: reveals [data-r] items inside <tea-lab-reveal> once they scroll into view.
   Content is only hidden while this element is defined, so nothing stays invisible if scripts fail. */
(function () {
  if (customElements.get('tea-lab-reveal')) return;
  class TeaLabReveal extends HTMLElement {
    connectedCallback() {
      if (this._on) return;
      this._on = true;
      var el = this;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var editor = window.Shopify && window.Shopify.designMode;
      if (this.getAttribute('data-anim') !== 'on' || reduce || editor || !('IntersectionObserver' in window)) {
        this.setAttribute('data-in', '');
        return;
      }
      this._io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { el.setAttribute('data-in', ''); el._io.disconnect(); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      this._io.observe(this);
    }
    disconnectedCallback() {
      this._on = false;
      if (this._io) this._io.disconnect();
    }
  }
  customElements.define('tea-lab-reveal', TeaLabReveal);
})();
